module.exports = __webpack_public_path__ + "img/img-main-03.2839deb1.svg";